/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserSearchRequest} from '../models/UserSearchRequest';
import type {UserSearchResult} from '../models/UserSearchResult';

export interface SearchUsers$Request {
    userSearchRequest?: UserSearchRequest;
}

export interface SearchUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchUsersRequest = createAction<PayloadData<void, SearchUsers$Request>>('USER_SEARCH__SEARCH_USERS__REQUEST');
export const searchUsersSuccess = createAction<PayloadData<UserSearchResult, SearchUsers$Request>>('USER_SEARCH__SEARCH_USERS__SUCCESS');
export const searchUsersFailure = createAction<PayloadData<Error, SearchUsers$Request, true>>('USER_SEARCH__SEARCH_USERS__FAILURE');

export const searchUsersActions = [
    searchUsersRequest,
    searchUsersSuccess,
    searchUsersFailure
] as const;

/**
 * Search users by criteria Return a empty list if no users match the criteria Return only sorted and filtered user IDs 
 * @param {UserSearchRequest} [meta.userSearchRequest] Search criteria for users
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchUsers = (meta: SearchUsers$Request, config?: SearchUsers$Config) => {
    return {
        CALL_API: {
            types: searchUsersActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/search`,
            TRANSPORT_REQUEST_BODY: meta.userSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

